// extracted by mini-css-extract-plugin
module.exports = {"tableFooter":"_1KL3GY4ipDI0QjayLgcYid"};